import {Component, Input, OnInit} from '@angular/core';
import {TestLink} from '../../../data/models/test-link';
import {MatDialog} from '@angular/material/dialog';
import {TestLinkCreateDialogComponent} from '../../dialogs/test-link-create-dialog/test-link-create-dialog.component';
import {TestLinkDeleteDialogComponent} from '../../dialogs/test-link-delete-dialog/test-link-delete-dialog.component';

@Component({
  selector: 'app-test-links-editor',
  templateUrl: './test-links-editor.component.html',
  styleUrls: ['./test-links-editor.component.css']
})
export class TestLinksEditorComponent implements OnInit {

  @Input() testId!: number;
  @Input() testLinks!: TestLink[];
  @Input() testType!: string;

  constructor(
    public dialog: MatDialog,
  ) {
  }

  ngOnInit(): void {
  }

  addTestLink(testLink: TestLink): void {
    this.testLinks = [...this.testLinks, testLink];
  }

  deleteTestLink(testLink: TestLink): void {
    this.testLinks = this.testLinks.filter(t => t.id !== testLink.id);
  }

  openTestLinkCreateDialog(): void {
    const dialogRef = this.dialog.open(TestLinkCreateDialogComponent, {
      width: '90vw',
      maxWidth: '500px',
      data: {testId: this.testId, testType: this.testType},
    });

    dialogRef.afterClosed().subscribe(testLink => {
      if (testLink) {
        this.addTestLink(testLink);
      }
    });
  }

  openTestLinkDeleteDialog(testLink: TestLink): void {
    const dialogRef = this.dialog.open(TestLinkDeleteDialogComponent, {
      data: {
        testId: this.testId,
        testLink,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteTestLink(testLink);
      }
    });
  }

}
